(() => {
  document.documentElement.classList.remove('no-js')

  const money = (cents) => {
    const currency = window.Shopify?.currency?.active || 'USD'
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency,
    }).format(cents / 100)
  }

  const escapeHtml = (value) => String(value ?? '').replace(/[&<>"]/g, (character) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
  })[character])

  const menuToggle = document.querySelector('[data-menu-toggle]')
  const mobileNav = document.querySelector('[data-mobile-nav]')
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', () => {
      const open = menuToggle.getAttribute('aria-expanded') === 'true'
      menuToggle.setAttribute('aria-expanded', String(!open))
      menuToggle.querySelector('[data-menu-label]').textContent = open ? 'Menu' : 'Close'
      mobileNav.classList.toggle('is-open', !open)
    })
    mobileNav.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => {
      menuToggle.setAttribute('aria-expanded', 'false')
      menuToggle.querySelector('[data-menu-label]').textContent = 'Menu'
      mobileNav.classList.remove('is-open')
    }))
  }

  document.querySelectorAll('[data-gallery]').forEach((gallery) => {
    const main = gallery.querySelector('[data-gallery-main]')
    gallery.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (!main) return
        main.src = thumb.dataset.image
        main.removeAttribute('srcset')
        gallery.querySelectorAll('[data-gallery-thumb]').forEach((item) => item.classList.remove('is-active'))
        thumb.classList.add('is-active')
      })
    })
  })

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const quantity = root.querySelector('[data-quantity]')
    root.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
      quantity.value = Math.max(1, Number(quantity.value || 1) - 1)
    })
    root.querySelector('[data-qty-plus]')?.addEventListener('click', () => {
      quantity.value = Math.max(1, Number(quantity.value || 1) + 1)
    })

    const sellingPlan = root.querySelector('[data-selling-plan]')
    root.querySelectorAll('[data-purchase-radio]').forEach((radio) => {
      radio.addEventListener('change', () => {
        root.querySelectorAll('[data-purchase-option]').forEach((option) => option.classList.remove('yh-selected'))
        radio.closest('[data-purchase-option]').classList.add('yh-selected')
        if (sellingPlan) {
          if (radio.value === 'subscription') {
            const subscriptionRadio = root.querySelector('[data-purchase-radio][value="subscription"]')
            sellingPlan.value = subscriptionRadio?.closest('form')?.querySelector('[data-selling-plan]')?.defaultValue || sellingPlan.defaultValue
          } else {
            sellingPlan.value = ''
          }
        }
      })
    })

    const variantSelect = root.querySelector('[data-variant-select]')
    variantSelect?.addEventListener('change', () => {
      const selected = variantSelect.options[variantSelect.selectedIndex]
      root.querySelector('[data-variant-id]').value = selected.value
      const price = root.querySelector('[data-one-time-price]')
      if (price) price.textContent = money(Number(selected.dataset.price))
    })
  })

  const layer = document.querySelector('[data-cart-layer]')
  const drawer = document.querySelector('[data-cart-drawer]')
  const lines = document.querySelector('[data-cart-lines]')
  const summary = document.querySelector('[data-cart-summary]')
  const empty = document.querySelector('[data-empty-cart]')
  const heading = document.querySelector('[data-cart-heading]')
  const total = document.querySelector('[data-cart-total]')

  const openCart = () => {
    if (!layer) return
    layer.hidden = false
    document.body.classList.add('yh-drawer-open')
    drawer?.focus()
  }

  const closeCart = () => {
    if (!layer) return
    layer.hidden = true
    document.body.classList.remove('yh-drawer-open')
  }

  const lineMarkup = (item) => {
    const sellingPlan = item.selling_plan_allocation?.selling_plan?.name
    const image = item.featured_image?.url || item.image
    return `
      <article class="yh-cart-line" data-line-key="${item.key}">
        ${image ? `<img src="${escapeHtml(image)}" alt="${escapeHtml(item.product_title)}" width="260" height="260">` : ''}
        <div>
          <h3>${escapeHtml(item.product_title)}</h3>
          ${sellingPlan ? `<p>${escapeHtml(sellingPlan)}</p>` : ''}
          <strong>${money(item.final_price)}</strong>
          <div class="yh-cart-line-actions">
            <div class="yh-quantity yh-quantity--small">
              <button type="button" data-cart-change="${item.key}" data-quantity="${Math.max(0, item.quantity - 1)}" aria-label="Decrease quantity">−</button>
              <span>${item.quantity}</span>
              <button type="button" data-cart-change="${item.key}" data-quantity="${item.quantity + 1}" aria-label="Increase quantity">+</button>
            </div>
            <button class="yh-remove-link" type="button" data-cart-change="${item.key}" data-quantity="0">Remove</button>
          </div>
        </div>
      </article>`
  }

  const renderCart = (cart) => {
    document.querySelectorAll('[data-cart-count]').forEach((count) => { count.textContent = cart.item_count })
    if (!lines || !summary || !empty || !heading) return
    lines.innerHTML = cart.items.map(lineMarkup).join('')
    const isEmpty = cart.item_count === 0
    empty.hidden = !isEmpty
    summary.hidden = isEmpty
    heading.textContent = isEmpty ? 'Your cart is empty.' : 'Your daily routine is ready.'
    if (total) total.textContent = money(cart.total_price)
  }

  const requestCart = async () => {
    const response = await fetch(`${window.Shopify.routes.root}cart.js`, { headers: { Accept: 'application/json' } })
    if (!response.ok) throw new Error('Unable to load cart')
    return response.json()
  }

  document.querySelectorAll('[data-cart-open]').forEach((button) => button.addEventListener('click', async () => {
    try { renderCart(await requestCart()) } catch (error) { console.error(error) }
    openCart()
  }))
  document.querySelector('[data-cart-close]')?.addEventListener('click', closeCart)
  layer?.addEventListener('click', (event) => { if (event.target === layer) closeCart() })
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeCart() })

  document.addEventListener('click', async (event) => {
    const change = event.target.closest('[data-cart-change]')
    if (!change) return
    change.disabled = true
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: change.dataset.cartChange, quantity: Number(change.dataset.quantity) }),
      })
      if (!response.ok) throw new Error('Unable to update cart')
      renderCart(await response.json())
    } catch (error) {
      console.error(error)
      change.disabled = false
    }
  })

  document.querySelectorAll('.js-product-form').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault()
      const button = form.querySelector('[data-add-button]')
      const original = button.textContent
      button.disabled = true
      button.textContent = 'Adding…'
      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form),
        })
        if (!response.ok) throw new Error('Unable to add this item to the cart')
        renderCart(await requestCart())
        openCart()
      } catch (error) {
        console.error(error)
        window.alert('We could not add this item. Please refresh and try again.')
      } finally {
        button.disabled = false
        button.textContent = original
      }
    })
  })

  document.querySelector('[data-checkout]')?.addEventListener('click', () => {
    window.location.href = `${window.Shopify.routes.root}checkout`
  })
})()
